import VueRollbar from 'vue-rollbar';

const rollbarConfig = {
  accessToken: '6ceb00419f6c456eb07977a555ee4e1a',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: process.env.NODE_ENV === 'production',
  source_map_enabled: true,
  environment: process.env.NODE_ENV,
  autoInstrument: {
    network: true,
    log: true,
    dom: true,
    navigation: true,
    connectivity: true,
  },
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.COMMIT_HASH || '',
        guess_uncaught_frames: true,
      },
    },
  },
  ignoredMessages: ['{"extraArgs":\\[{.*', '\\(unknown\\): Script error\\.', 'Network Error'],
  hostSafeList: ['webpack', 'owner.retty.me', 'owner-staging.retty.me'],
};

// app: Vue instance
const registerRollbarForVue = vue => {
  vue.use(VueRollbar, rollbarConfig);
  vue.config.errorHandler = error => {
    console.error(error);
    vue.rollbar.error(error);
  };
};

export default registerRollbarForVue;
